export const environment = {
    env: 'test',
    production: true,
    API_URL: '/api',
    APP_VERSION: '3.6.6',
    ADMIN_VERSION: '3.6.6',
    APP_URL: 'https://test-app.cosmosengineering.online',
    ADMIN_URL: 'https://test-admin.cosmosengineering.online',
    POSTHOG_API_KEY: 'phc_vgpvfE5zdMCqcKpzmN9M3c71M7QtqQ6R1Dl3t6Kx5LW',
    POSTHOG_HOST: 'https://eu.i.posthog.com'
};
